import { useEffect, useState } from 'react';

import useMenus from '../../context/MenuContext';
import useParam from '../../context/ParamContext';
import TabsUI from '../Interface/TabsUI';

import CompanyActive from './CompanyActive';
import CompanyDayOff from './CompanyDayOff';
import MachineActive from './MachineActive';
import MachineDayOff from './MachineDayOff';
import { ProvincePage } from './ProvincePage';
import masterDataService from '../../service/masterData.service';
import { generateAutocompleteItems } from '../../utils/helper';

const ActiveTimePage = () => {
  const { menus, getMenus, getMenuSubMenuId, getCanEdit } = useMenus();
  const { getParam, params } = useParam();
  const [activeTab, setActiveTab] = useState(0);
  const [canEdit, setCanEdit] = useState(true);
  const [autocompleteOptions, setAutocompleteOptions] = useState({
    resources: [],
  });

  useEffect(() => {
    getMenus();
    getParam();
    initDefaultValues();
  }, []);

  useEffect(() => {
    const submenuId = getMenuSubMenuId('activeTime');
    setCanEdit(getCanEdit(submenuId));
  }, [menus]);

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const initDefaultValues = () => {
    masterDataService
      .getQNTResources()
      .then((data) => {
        const aData = {
          resources: data,
        };

        const acOptions = {
          resources: generateAutocompleteItems(aData.resources, 'resourceName', 'resourceId'),
        };
        setAutocompleteOptions(acOptions);
      })
      .finally(() => {});
  };

  const todoTabs = [
    {
      id: 0,
      name: 'Cég menetidő',
      content: <CompanyActive isAdditional={false} canEdit={canEdit} />,
    },
    {
      id: 1,
      name: 'Cég plusz napok',
      content: <CompanyActive isAdditional={true} canEdit={canEdit} />,
    },
    {
      id: 2,
      name: 'Cég szabadnapok',
      content: <CompanyDayOff canEdit={canEdit} />,
    },
    {
      id: 3,
      name: 'Gép menetidő',
      content: <MachineActive isAdditional={false} canEdit={canEdit} autocompleteOptions={autocompleteOptions} />,
    },
    {
      id: 4,
      name: 'Gép plusz napok',
      content: <MachineActive isAdditional={true} canEdit={canEdit} autocompleteOptions={autocompleteOptions} />,
    },
    {
      id: 5,
      name: 'Gép szabadnapok',
      content: <MachineDayOff canEdit={canEdit} autocompleteOptions={autocompleteOptions} />,
    },
    ...(params.PROVINCE_FIELD_AND_TAB === 'Y'
      ? [
          {
            id: 6,
            name: 'Tartomány szabadnapok',
            content: <ProvincePage canEdit={canEdit} />,
          },
        ]
      : []),
  ];

  return (
    <div className="fixed top-16 inset-0 gap-4 bg-gray-100 p-4 h-full overflow-x-auto">
      <div>
        <div className="flex justify-center w-full mr-auto ml-auto">
          <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
            {todoTabs.map((tab, index) => (
              <div key={index} name={tab.name}>
                {tab.content}
              </div>
            ))}
          </TabsUI>
        </div>
      </div>
    </div>
  );
};

export default ActiveTimePage;
